import styled from 'styled-components';
import Combobox from '../Combobox/Combobox.js';

const AutocompleteUnstyledInput = styled(Combobox.Input).withConfig({
  displayName: "_AutocompleteUnstyledInput__AutocompleteUnstyledInput",
  componentId: "sc-6k9dpc-0"
})(["border:0;font-size:inherit;font-family:inherit;background-color:transparent;-webkit-appearance:none;color:inherit;width:100%;&:focus{outline:0;}"]);

export { AutocompleteUnstyledInput };
